"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.luckyWheelConfigInfoApi = luckyWheelConfigInfoApi;
exports.luckyWheelConfigSaveApi = luckyWheelConfigSaveApi;
exports.luckyWheelCopyInfoApi = luckyWheelCopyInfoApi;
exports.luckyWheelCouponListApi = luckyWheelCouponListApi;
exports.luckyWheelCouponUseStatusListApi = luckyWheelCouponUseStatusListApi;
exports.luckyWheelDeleteApi = luckyWheelDeleteApi;
exports.luckyWheelEndApi = luckyWheelEndApi;
exports.luckyWheelInfoApi = luckyWheelInfoApi;
exports.luckyWheelPageApi = luckyWheelPageApi;
exports.luckyWheelPrizeTypeListApi = luckyWheelPrizeTypeListApi;
exports.luckyWheelRecordExportApi = luckyWheelRecordExportApi;
exports.luckyWheelRecordExportCountApi = luckyWheelRecordExportCountApi;
exports.luckyWheelRecordPageApi = luckyWheelRecordPageApi;
exports.luckyWheelRecordPrizeStatusListApi = luckyWheelRecordPrizeStatusListApi;
exports.luckyWheelRecordResultListApi = luckyWheelRecordResultListApi;
exports.luckyWheelSaveApi = luckyWheelSaveApi;
exports.luckyWheelSkuInfoApi = luckyWheelSkuInfoApi;
exports.luckyWheelUpdateApi = luckyWheelUpdateApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var ACTIVITY_BASE = '/admin/activity/lucky/wheel/activity';

/**
 * 活动分页列表
 * GET query: page、limit、keyword、status
 */
function luckyWheelPageApi() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var query = {
    page: params.page,
    limit: params.limit
  };
  var keyword = params.keyword != null ? String(params.keyword).trim() : '';
  if (keyword) query.keyword = keyword;
  if (params.status !== '' && params.status != null) query.status = params.status;
  return (0, _request.default)({
    url: "".concat(ACTIVITY_BASE, "/list"),
    method: 'get',
    params: query
  });
}

/**
 * 活动详情（编辑 / 查看回显）
 * GET query: id
 */
function luckyWheelInfoApi(id) {
  return (0, _request.default)({
    url: "".concat(ACTIVITY_BASE, "/info"),
    method: 'get',
    params: {
      id: id
    }
  });
}

/**
 * 复制活动详情（清空活动名称、适用分销客户）
 * GET query: id
 */
function luckyWheelCopyInfoApi(id) {
  return (0, _request.default)({
    url: "".concat(ACTIVITY_BASE, "/copyInfo"),
    method: 'get',
    params: {
      id: id
    }
  });
}

/**
 * 新增活动
 */
function luckyWheelSaveApi(body) {
  return (0, _request.default)({
    url: "".concat(ACTIVITY_BASE, "/save"),
    method: 'post',
    data: body || {}
  });
}

/**
 * 编辑活动（仅未开始）
 */
function luckyWheelUpdateApi(body) {
  return (0, _request.default)({
    url: "".concat(ACTIVITY_BASE, "/update"),
    method: 'post',
    data: body || {}
  });
}

/**
 * 删除活动（仅未开始）
 * GET query: id
 */
function luckyWheelDeleteApi(id) {
  return (0, _request.default)({
    url: "".concat(ACTIVITY_BASE, "/delete"),
    method: 'get',
    params: {
      id: id
    }
  });
}

/**
 * 结束活动（仅进行中）
 * GET query: id
 */
function luckyWheelEndApi(id) {
  return (0, _request.default)({
    url: "".concat(ACTIVITY_BASE, "/end"),
    method: 'get',
    params: {
      id: id
    }
  });
}

/**
 * 奖项类型枚举
 */
function luckyWheelPrizeTypeListApi() {
  return (0, _request.default)({
    url: "".concat(ACTIVITY_BASE, "/prizeType/list"),
    method: 'get'
  });
}

/**
 * 优惠券下拉（满减券 couponType=1，满折券 couponType=2）
 */
function luckyWheelCouponListApi() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var query = {};
  if (params.couponType != null && params.couponType !== '') {
    query.couponType = params.couponType;
  }
  if (params.name) query.name = params.name;
  return (0, _request.default)({
    url: "".concat(ACTIVITY_BASE, "/coupon/list"),
    method: 'get',
    params: query
  });
}

/**
 * 根据 skuId 查询商品名称和库存
 */
function luckyWheelSkuInfoApi(skuId) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return (0, _request.default)({
    url: "".concat(ACTIVITY_BASE, "/sku/info"),
    method: 'get',
    params: {
      skuId: skuId
    },
    __skipGlobalErrorMessage: !!options.silent
  });
}

/**
 * 获取幸运大转盘装修配置
 * GET /api/admin/activity/lucky/wheel/getConfig
 */
function luckyWheelConfigInfoApi() {
  return (0, _request.default)({
    url: '/admin/activity/lucky/wheel/getConfig',
    method: 'get'
  });
}

/**
 * 保存幸运大转盘装修配置
 * POST /api/admin/activity/lucky/wheel/config
 */
function luckyWheelConfigSaveApi(body) {
  return (0, _request.default)({
    url: '/admin/activity/lucky/wheel/config',
    method: 'post',
    data: body || {}
  });
}
var RECORD_BASE = '/admin/activity/lucky/wheel/record';

/**
 * 抽奖记录分页
 * GET query: page、limit、keyword、prizeType、result、customerId、prizeStatus、couponUseStatus
 * 优惠券使用状态 couponUseStatus：1 已使用、2 待使用、3 已过期（不适用时为 null）
 * 列表新增 couponUseStatus、couponUseStatusDesc、relatedOrderNo（关联订单号，无值为 null）
 * 后端固定按抽奖时间降序
 */
function luckyWheelRecordPageApi() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var query = {
    page: params.page,
    limit: params.limit
  };
  var keyword = params.keyword != null ? String(params.keyword).trim() : '';
  if (keyword) query.keyword = keyword;
  if (params.prizeType !== '' && params.prizeType != null) query.prizeType = params.prizeType;
  if (params.result !== '' && params.result != null) query.result = params.result;
  if (params.customerId !== '' && params.customerId != null) query.customerId = params.customerId;
  if (params.prizeStatus !== '' && params.prizeStatus != null) query.prizeStatus = params.prizeStatus;
  if (params.couponUseStatus !== '' && params.couponUseStatus != null) query.couponUseStatus = params.couponUseStatus;
  return (0, _request.default)({
    url: "".concat(RECORD_BASE, "/list"),
    method: 'get',
    params: query
  });
}

/** 抽奖记录导出，返回 { fileName } 文件地址；exportAll 为必传布尔值。 */
function luckyWheelRecordExportApi() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _request.default)({
    url: "".concat(RECORD_BASE, "/export"),
    method: 'get',
    params: params
  });
}

/** 当前筛选与全部记录的导出数量。 */
function luckyWheelRecordExportCountApi() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _request.default)({
    url: "".concat(RECORD_BASE, "/export/count"),
    method: 'get',
    params: params
  });
}
function luckyWheelCouponUseStatusListApi() {
  return (0, _request.default)({
    url: "".concat(RECORD_BASE, "/couponUseStatus/list"),
    method: 'get'
  });
}

/**
 * 奖品状态枚举
 */
function luckyWheelRecordPrizeStatusListApi() {
  return (0, _request.default)({
    url: "".concat(RECORD_BASE, "/prizeStatus/list"),
    method: 'get'
  });
}

/**
 * 抽奖结果枚举
 */
function luckyWheelRecordResultListApi() {
  return (0, _request.default)({
    url: "".concat(RECORD_BASE, "/result/list"),
    method: 'get'
  });
}